import './sectors.component.js';
import './vacancies.component.js';
import './filters.component.js';
import './values.component.js';

import './testimonials.component.js';
import './roles.component.js';
import './process.component.js';
import './teams.component.js';
import './studies.component.js';
import './services.component.js';
import './similar-jobs.component.js';
import './our-offices.component.js';
import './history.component.js';
import './stats.component.js';
import './propositions.component.js';
import './solve-problems.component.js';
import './disciplines.component.js';
import './talent-expertise.component.js';